<div class="header-navigation">
  <span>Shipments</span>
</div>
@if (!loading) {
  <div class="list-container">
    <!-- search filter -->
    @if (upcomingShipment && currentTab === 1) {
      <div class="search-filter-container">
        <div class="search-input-wrapper">
          <mat-form-field appearance="outline" class="search-field">
            <mat-icon matPrefix svgIcon="magnifying-glass" data-test="search"></mat-icon>
            <input
              matInput
              placeholder="Search shipments..."
              (input)="onSearchInput(searchInput.value)"
              #searchInput
              [value]="currentSearchInput"
              />
          </mat-form-field>
        </div>
        <div class="filter-buttons-group">
          <button mat-flat-button class="filter-btn" (click)="navigateToFilterShipments()" data-test="filter">
            <mat-icon svgIcon="filter"></mat-icon>
            Filter
          </button>
          <button mat-flat-button class="sort-btn" (click)="sortByStatus()" data-test="sort">
            <mat-icon svgIcon="sort"></mat-icon>
            Sort
          </button>
        </div>
      </div>
    }
    @if (upcomingShipment && currentTab === 1) {
      <div class="tag-container">
        @for (tag of tagsList; track tag) {
          <div>
            <span>{{ tag }}</span>
          </div>
        }
      </div>
    }
    <mat-tab-group
      animationDuration="0ms"
      mat-align-tabs="center"
      mat-stretch-tabs="true"
      class="tab-list"
      (selectedTabChange)="tabChanged($event?.index)"
      [selectedIndex]="currentTab"
      >
      <mat-tab label="Ongoing" data-test="ongoing-shipment-tab">
        @if (ongoingShipment) {
          @for (shipment of ongoingShipment; track shipment) {
            <div>
              <app-shipments-item
                [shipment]="shipment"
                [isUpcoming]="false"
                (onReload)="loadShipments()"
                (onChangeStatus)="onShipmentChangeStatus($event)"
              ></app-shipments-item>
            </div>
          }
        }
        @if (!ongoingShipment?.length) {
          <app-no-shipment
            [message]="noOngoingShipment"
            [isShipmentListPage]="true"
            icon="shipments"
            >
          </app-no-shipment>
        }
      </mat-tab>
      <mat-tab label="Upcoming" data-test="upcoming-shipment-tab">
        @if (upcomingShipment) {
          @for (shipment of upcomingShipment; track shipment) {
            <div>
              <app-shipments-item
                [shipment]="shipment"
                [isUpcoming]="true"
                [isOngoingFTL]="isOngoingFTL"
                [isOngoingCount]="ongoingShipment.length"
                (onReload)="loadShipments()"
                (onChangeStatus)="onShipmentChangeStatus($event)"
              ></app-shipments-item>
            </div>
          }
        }
      </mat-tab>
    </mat-tab-group>
    @if (currentTab === 1 && !upcomingShipment?.length) {
      <app-no-shipment
        [message]="this.someTruthy || this.currentSearchInput ? noShipment : noUpcomingShipment"
        [isShipmentListPage]="true"
        icon="shipments"
      ></app-no-shipment>
    }
  </div>
}
